import RecapLoves from 'components/Content/Recap/RecapLoves/RecapLoves';

export default RecapLoves;
